// import { Carousel } from "@material-tailwind/react";
import {
  IconCircleCheck,
  IconExclamationCircle,
  IconLoader,
  IconSignRight,
  IconSparkles,
  IconShield,
  IconUsers,
} from "@tabler/icons-react";
import { motion, AnimatePresence } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import BannerImg from "../../assets/Images/BannerImg.webp";
import p2 from "../../assets/Images/c2.webp";
import p3 from "../../assets/Images/c3.webp";
import p4 from "../../assets/Images/c4.webp";
import f2 from "../../assets/Images/Car.png";
import f3 from "../../assets/Images/Coffee.png";
import f8 from "../../assets/Images/Housekeeping.png";
import m1 from "../../assets/Images/m1.webp";
import m2 from "../../assets/Images/m2.webp";
import m3 from "../../assets/Images/m3.webp";
import m4 from "../../assets/Images/m4.webp";
import m5 from "../../assets/Images/m5.webp";
import m6 from "../../assets/Images/m6.webp";
import f7 from "../../assets/Images/Office.png";
import f5 from "../../assets/Images/Priting.png";
import f6 from "../../assets/Images/Support.png";
import f1 from "../../assets/Images/wifi.png";
import "./style.css";
import "swiper/css/navigation";
import "swiper/css/pagination";
// import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import LazyLoad from "react-lazyload";
import { Link, useNavigate } from "react-router-dom";
import ac from "../../assets/Images/ac.png";
import bus from "../../assets/Images/busstop.png";
import sports from "../../assets/Images/football.png";
import mall from "../../assets/Images/mall.png";
import metro from "../../assets/Images/metro.png";
import movie from "../../assets/Images/movie.png";
import power from "../../assets/Images/power.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import ArrowRight from '../../asset/ArrowRight.svg'
import LaunchpodMini from '../../asset/LaunchpodMini.jpg'
import PerungudiMini from '../../asset/PerungudiMini.jpg'
import MountRoadMini from '../../asset/MountRoadMini.jpg'
import MaskClock from '../../asset/MaskClock.png'
import MaskSecurity from '../../asset/MaskSecurity.png'
import MaskWifi from '../../asset/maskWifi.png'
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import OffisbaySpace1 from '../../assets/Images/CoworkingSpace.png'
import OffisbaySpace2 from '../../assets/Images/MeetingRoom.jpg'
import OffisbaySpace3 from '../../assets/Images/PrivateOffice.jpeg'
import OffisbaySpace4 from '../../assets/Images/virtual_office.jpg'
import partnerContent from '../../data/partners.json';

const Home = () => {
  const coworkingData = [
    {
      id: 1,
      title: "Co-working Spaces",
      descriptionPoints: [
        "Trade in cubicles for conversations, and isolation for inspiration! Whether you’re a solo freelancer or part of a dynamic duo, our vibrant co-working spaces are designed to fuel creativity and boost productivity. Pick your spot, grab a coffee, and get to work alongside some seriously cool people.",
        "Jump into the Commons and create something amazing today!",
      ],
      coverImage: m1,
      sliderImages: [m1, m2],
    },
    {
      id: 2,
      title: "Meeting Rooms ",
      descriptionPoints: [
        "Why settle for boring boardrooms when you can have Brainstorm Boulevard? Whether it’s a big pitch, a team huddle, or a strategy session, our stylish and tech-savvy meeting rooms are ready to handle it all—with a side of free coffee and a whole lot of good vibes.",
        "Book your spot on the Boulevard and make things happen!",
      ],
      coverImage: m2,
      sliderImages: [m2, m3],
    },
    {
      id: 3,
      title: "Virtual Office Services",
      descriptionPoints: [
        "Make a big impression without the big expense! With our Virtual Office Services, get a prestigious address, mail handling, and all the perks of an office without actually having to be there. It’s your office in the cloud, so you can stay grounded wherever you are.",
        "Get your Cloud HQ and level up your business presence!",
      ],
      coverImage: m6,
      sliderImages: [m3, m4],
    },
    {
      id: 4,
      title: "Business Support Services",
      descriptionPoints: [
        "Leave the grunt work to us! Our Task Force is here to handle your admin, tech troubles, and all those pesky little things that steal your focus. We keep the gears turning so you can keep the ideas flowing.",
        "Deploy the Task Force and focus on what you do best!",
      ],
      coverImage: m4,
      sliderImages: [m4, m5],
    },
  ];

  const workSpaceData = [
    {
      id: 1,
      roomName: "Hot Desk",
      image: m1,
    },
    {
      id: 2,
      roomName: "Private Rooms",
      image: m2,
    },
    {
      id: 3,
      roomName: "Virtual Office",
      image: m3,
    },
    {
      id: 4,
      roomName: "Meeting Rooms",
      image: m4,
    },
  ];

  const features = [
    {
      id: 1,
      title: "Lightning-fast Internet",
      image: f1,
    },
    {
      id: 2,
      title: "Great Coffee, Tea and Munchies",
      image: f3,
    },
    {
      id: 3,
      title: "Super Housekeeping",
      image: f8,
    },
    {
      id: 4,
      title: "Professional IT Support",
      image: f6,
    },
    {
      id: 5,
      title: "Efficient Printing and Scanning Service",
      image: f5,
    },
    {
      id: 6,
      title: "Office Supplies",
      image: f7,
    },
    {
      id: 7,
      title: "Car Parking",
      image: f2,
    },
    {
      id: 8,
      title: "AC",
      image: ac,
    },
    {
      id: 9,
      title: "Power Backup",
      image: power,
    },
  ];
  const nearbyConvenience = [
    {
      id: 1,
      title: "Metro Rail",
      distance: "(100m)",
      image: metro,
    },
    {
      id: 2,
      title: "Bus Stop",
      distance: "(50m)",
      image: bus,
    },
    {
      id: 3,
      title: "Nearby Mall",
      distance: "(500m)",
      image: mall,
    },
    {
      id: 4,
      title: "Independent Sports Center",
      distance: "(10m)",
      image: sports,
    },
    {
      id: 5,
      title: "Movie Theater",
      distance: "(100m)",
      image: movie,
    },
  ];

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
  });

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle");
  const heroRef = useRef(null);
  const images = [MountRoadMini, LaunchpodMini, PerungudiMini];
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef(null);
  const leftRef = useRef(null);

  useEffect(() => {
    if (status !== "idle") {
      const timer = setTimeout(() => setStatus("idle"), 5000);
      return () => clearTimeout(timer);
    }
  }, [status]);


  const validate = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Name is required.";
    } else if (/\d/.test(formData.fullName)) {
      newErrors.name = "Name cannot contain numbers.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Invalid email address.";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required.";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone number must be 10 digits.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        setStatus("loading");
        const response = await fetch("https://offisbay.com/contactus.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });

        if (response.ok) {
          setStatus("success");
          setErrors({});
          setFormData({
            fullName: "",
            email: "",
            phone: "",
          });
        } else {
          setStatus("error");
        }
      } catch (error) {
        setStatus("error");
      }
    }
  };

  const navigate = useNavigate();

  const handleExplore = (title) => {
    switch (title) {
      case "Co-working Spaces":
        navigate("/mount-road-chennai");
        break;
      case "Meeting Rooms":
        navigate("/meeting-room");
        break;
      case "Business Support Services":
        navigate("/mount-road-chennai");
        break;
      case "Virtual Office Services":
        navigate("/virtual-office-chennai");
        break;
      default:
        navigate("/");
        break;
    }
  };

  const locationLinks = [
    {
      image: MountRoadMini,
      title: "Offisbay - Mount Road",
      link: "https://www.offisbay.com/mount-road-chennai",
      description: 'Premium Workspace Destination'
    },
    {
      image: LaunchpodMini,
      title: "Launchpod",
      link: "https://thelaunchpod.offisbay.com/",
      description: 'Elegent Event Space'
    },
    {
      image: PerungudiMini,
      title: "Offisbay - Perungudi",
      link: "https://offisbay.com/affordable-coworking-space-perungudi",
      description: 'Premium Workspace Destination'
    },
  ];

  const partnersPreview = partnerContent.partners.slice(0, 3);


  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    // Animate the first section down as scroll starts
    gsap.to('.heroText', {
      y: 550, // how much it should move down
      opacity: 0, // slight fade for depth
      scale: 0.8,
      ease: "power2.out",
      scrollTrigger: {
        trigger: '.heroTextTrigger', // trigger entire page scroll
        scroller: 'html',
        start: 'top 50%',
        end: 'top top',
        scrub: 1, // smooth animation linked to scroll
        // markers: true
      },
    });
  }, []);

  // useEffect(() => {
  //   const ctx = gsap.context(() => {
  //     // Pin the left text section
  //     ScrollTrigger.create({
  //       trigger: sectionRef.current,
  //       start: "top top",
  //       end: "bottom bottom",
  //       pin: leftRef.current,
  //       scrub: true,
  //     });

  //     // Animate each right card as it appears
  //     gsap.utils.toArray(".service-card").forEach((card) => {
  //       gsap.from(card, {
  //         opacity: 0,
  //         y: 80,
  //         duration: 1,
  //         ease: "power2.out",
  //         scrollTrigger: {
  //           trigger: card,
  //           start: "top 90%",
  //           toggleActions: "play none none reverse",
  //         },
  //       });
  //     });
  //   }, sectionRef);

  //   return () => ctx.revert();
  // }, []);

  useEffect(() => {
  gsap.registerPlugin(ScrollTrigger);

  let mm = gsap.matchMedia();

  mm.add("(min-width: 768px)", () => {
    // Desktop only
    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: "top top",
      end: "bottom bottom",
      pin: leftRef.current,
      scrub: true,
    });

    gsap.utils.toArray(".service-card").forEach((card) => {
      gsap.from(card, {
        opacity: 0,
        y: 80,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: card,
          start: "top 90%",
        },
      });
    });
  });

  // mobile animations (no pin)
  mm.add("(max-width: 767px)", () => {
    gsap.utils.toArray(".service-card").forEach((card) => {
      gsap.from(card, {
        opacity: 0,
        y: 40,
        duration: 0.8,
        ease: "power2.out",
        scrollTrigger: {
          trigger: card,
          start: "top 95%",
        },
      });
    });
  });

  return () => mm.revert();
}, []);


  const services = [
    { img: OffisbaySpace1, title: "Co-working Spaces" },
    { img: OffisbaySpace2, title: "Meeting Rooms" },
    { img: OffisbaySpace3, title: "Business Support Services" },
    { img: OffisbaySpace4, title: "Virtual Office Services" },
  ];

  return (
    <>
      {/* <section
        id="requestcallback"
        className="min-h-screen flex flex-col items-center justify-center font-RedHat "
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.3)),url(${BannerImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          // backgroundAttachment: "fixed",
        }}
      >
        <div className="w-[90%] h-full text-white flex flex-col items-center gap-5 lg:mt-36 md:mt-36">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false }}
            transition={{ ease: "easeInOut", duration: 0.5 }}
            className="text-4xl font-RedHat font-bold text-center"
          >
            Your Next Great Workspace Awaits
          </motion.h1>
          <p className="text-center font-Montserrat">
            Get Started Today! Fill in your details below and take the first
            step toward transforming your work life
          </p>
          <div className="relative h-fit  w-fit ">
            <form
              className="flex flex-col gap-4 items-center justify-center w-full"
              onSubmit={handleSubmit}
            >
              <div className="flex flex-row flex-wrap items-center justify-center gap-5 w-fit">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false }}
                  transition={{ ease: "easeInOut", duration: 0.5 }}
                >
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    placeholder="Name"
                    value={formData.fullName}
                    onChange={handleChange}
                    className={`outline-none border-2 py-1 bg-white rounded-md indent-3 text-primary ${
                      errors.fullName ? "border-red-500" : "border-transparent"
                    } focus:border-primary`}
                  />
                  {errors.fullName && (
                    <p className="text-red-500 text-sm">{errors.fullName}</p>
                  )}
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false }}
                  transition={{ ease: "easeInOut", duration: 0.5 }}
                >
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                    className={`outline-none border-2 py-1 bg-white rounded-md indent-3 text-primary ${
                      errors.email ? "border-red-500" : "border-transparent"
                    } focus:border-primary`}
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm">{errors.email}</p>
                  )}
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false }}
                  transition={{ ease: "easeInOut", duration: 0.5 }}
                >
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    min={10}
                    max={10}
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                    className={`outline-none border-2 py-1 bg-white rounded-md indent-3 text-primary ${
                      errors.phone ? "border-red-500" : "border-transparent"
                    } focus:border-primary`}
                  />
                  {errors.phone && (
                    <p className="text-red-500 text-sm">{errors.phone}</p>
                  )}
                </motion.div>
              </div>

              <motion.button
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false }}
                transition={{ ease: "easeInOut", duration: 0.5 }}
                className="bg-primary py-2 px-8 text-[0.8rem] rounded-md font-Montserrat relative group"
                type="submit"
              >
                <div className="absolute inset-0 bg-white/10 w-0 group-hover:w-full transition-all ease-in-out duration-300 rounded-md"></div>
                Request a Call Back
              </motion.button>
            </form>
            {status === "loading" && (
              <div className="absolute inset-0 rounded-lg bg-white/80 flex flex-col items-center justify-center gap-5">
                <motion.div
                  initial={{ opacity: 0.5, rotate: 0 }}
                  animate={{ opacity: 1, rotate: 360 }}
                  transition={{
                    duration: 3,
                    ease: "easeInOut",
                    repeat: Infinity,
                    repeatType: "mirror",
                  }}
                >
                  <IconLoader size={24} className="stroke-green-600" />
                </motion.div>
                <h3 className="text-base text-center font-semibold text-green-600">
                  Sending message . . .
                </h3>
              </div>
            )}
            {status === "success" && (
              <div className="absolute inset-0 bg-white/80 rounded-lg flex flex-col items-center justify-center gap-2">
                <motion.div
                  initial={{ opacity: 0.5, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 1.5,
                    ease: "easeInOut",
                    repeat: Infinity,
                    repeatType: "mirror",
                  }}
                >
                  <IconCircleCheck size={24} className="stroke-green-600" />
                </motion.div>
                <h3 className="text-base text-center font-semibold text-green-600">
                  Your message has been sent successfully
                </h3>
              </div>
            )}
            {status === "error" && (
              <div className="absolute inset-0 bg-white/80 rounded-lg flex flex-col items-center justify-center gap-5">
                <motion.div
                  initial={{ opacity: 0.5, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 1.5,
                    ease: "easeInOut",
                    repeat: Infinity,
                    repeatType: "mirror",
                  }}
                >
                  <IconExclamationCircle size={24} className="stroke-red-600" />
                </motion.div>
                <h3 className="text-base text-center font-semibold capitalize text-red-600">
                  Something went wrong please try again later
                </h3>
              </div>
            )}
          </div>
        </div>
      </section> */}

      <section ref={heroRef} className="heroSection relative max-w-7xl font-satoshi h-[140vh] mx-auto flex flex-col items-center justify-center text-center px-4 py-20 bg-[#fff4f8] rounded-b-3xl">
        {/* Rating */}
        <div className="heroText">
          <div className="flex items-center justify-center mb-4 space-x-2">
            <div className="text-[#ff9f40] text-2xl">★★★★★</div>
            <p className="text-[#2E2E2E] text-xl font-medium">
              Trusted by many Startups & Freelancers
            </p>
          </div>

          {/* Heading */}
          <h1 className=" text-5xl md:text-7xl font-extrabold text-[#2E2E2E] leading-tight mb-4">
            Your Next Great <br className="hidden md:block" /> Workspace Awaits
          </h1>

          {/* Subtext */}
          <p className="heroTextTrigger text-gray-500 text-xl mb-12 mt-8 max-w-2xl">
            Get Started Today! Fill in your details below and take the first step
            toward transforming your work life.
          </p>

          {/* CTA Button */}
          <div className="w-full ">
            <button className="flex items-center mx-auto justify-between gap-4 bg-[#966376] text-white pr-1 pl-8 py-1 rounded-full text-xl font-[500] shadow-lg hover:scale-105 transition-transform duration-200">
              Request a Call Back
              <span className="bg-white p-4 rounded-full flex items-center justify-center">
                {/* Arrow icon placeholder */}
                <img
                  src={ArrowRight}
                  alt="arrow"
                />
              </span>
            </button>
          </div>

          {/* Feature Row */}
          <div className="flex flex-wrap justify-center gap-8 mt-12 text-[grey] font-medium">
            <div className="flex items-center gap-2">
              <img
                src={MaskClock}
                alt="clock"
                className="w-4 h-4"
              />
              <span>12 HRS ACCESS</span>
            </div>
            <div className="flex items-center gap-2">
              <img
                src={MaskWifi}
                alt="wifi"
                className="w-4 h-4"
              />
              <span>FAST CONNECTIVITY</span>
            </div>
            <div className="flex items-center gap-2">
              <img
                src={MaskSecurity}
                alt="shield"
                className="w-4 h-4"
              />
              <span>SECURE INTERNET</span>
            </div>
          </div>
        </div>

        <div className="h-[200px] w-4" />
      </section>

      {/* Location Section */}

<div className="nextGen relative w-full flex justify-center">
  <div className="absolute -bottom-60 w-full md:w-[70%] rounded-3xl overflow-hidden flex flex-col md:flex-row items-center gap-6 md:gap-8">
    <div className="relative w-full overflow-hidden rounded-2xl">
      <AnimatePresence mode="wait">
        <motion.div key={activeIndex} className="relative w-full">
          {/* Main Image */}
          <motion.img
            src={locationLinks[activeIndex].image}
            alt={`Workspace ${activeIndex + 1}`}
            className="w-full h-[450px] object-cover rounded-2xl"
            initial={{
              opacity: 0,
              x: activeIndex % 2 === 0 ? 100 : -100,
              scale: 1.05,
              filter: "blur(6px)",
            }}
            animate={{
              opacity: 1,
              x: 0,
              scale: 1,
              filter: "blur(0px)",
            }}
            exit={{
              opacity: 0,
              x: activeIndex % 2 === 0 ? -100 : 100,
              scale: 0.98,
              filter: "blur(6px)",
            }}
            transition={{
              duration: 0.8,
              ease: [0.25, 0.8, 0.25, 1],
            }}
          />

          {/* 🔳 Bottom Fade Overlay */}
          <div className="absolute bottom-0 left-0 right-0 h-[45%] bg-gradient-to-t from-black/70 via-black/30 to-transparent rounded-b-2xl" />

          {/* 🌟 Text & CTA Row */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ delay: 0.3, duration: 0.6, ease: "easeOut" }}
            className="absolute bottom-0 left-0 right-0 flex justify-between items-end px-6 md:px-10 pb-6 text-white"
          >
            {/* Left Text */}
            <div className="flex flex-col">
              <h3 className="text-xl md:text-2xl font-semibold drop-shadow-md">
                {locationLinks[activeIndex].title}
              </h3>
              <p className="text-sm text-gray-300">
                {locationLinks[activeIndex].description}
              </p>
            </div>

            {/* Right CTA */}
            <motion.a
              href={locationLinks[activeIndex].link}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center gap-2 bg-white/15 border border-white/30 backdrop-blur-md hover:bg-white/25 text-white px-6 py-2 rounded-full text-sm md:text-base font-medium shadow-[0_4px_10px_rgba(0,0,0,0.3)] transition-all"
            >
              Visit Now
              <img style={{ filter: "brightness(5)" }} src={ArrowRight} alt="arrow" className="w-4" />
            </motion.a>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </div>

    {/* Thumbnail Section */}
    <div className="flex md:flex-col flex-row md:space-y-5 space-x-4 md:space-x-0 items-center justify-center">
      {locationLinks.map((loc, index) => (
        <motion.div
          key={index}
          onClick={() => setActiveIndex(index)}
          className={`relative cursor-pointer rounded-2xl overflow-hidden transition-all duration-500 ease-[cubic-bezier(0.25,0.8,0.25,1)] ${
            activeIndex === index
              ? "scale-105 shadow-[0_0_20px_rgba(150,99,118,0.45)]"
              : "hover:scale-105 hover:shadow-[0_0_10px_rgba(150,99,118,0.25)]"
          }`}
          whileHover={{ y: -3 }}
          whileTap={{ scale: 0.96 }}
        >
          <motion.img
            src={loc.image}
            alt={loc.title}
            className="w-[160px] h-[110px] md:w-[180px] md:h-[120px] object-cover rounded-2xl"
            transition={{ duration: 0.3 }}
          />
          {activeIndex === index && (
            <motion.div
              layoutId="activeBar"
              className="absolute left-0 top-0 bottom-0 w-[10px] bg-[#966376ae] rounded-r-full shadow-[0_0_8px_rgba(150,99,118,0.8)]"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "100%", opacity: 1 }}
              transition={{ duration: 0.4 }}
            />
          )}
        </motion.div>
      ))}
    </div>
  </div>
</div>



      <section
        ref={sectionRef}
        className="relative mt-[20rem] pb-0 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 py-24 md:pt-36 px-6 font-satoshi"
      >
        {/* Left pinned text */}
        <div ref={leftRef} className="flex flex-col justify-start space-y-4 md:sticky md:top-0 md:h-screen pt-5 md:pt-32">

          <h1 className="text-5xl md:text-6xl font-bold text-black leading-tight">
            Explore Our <br /><span className="text-[#966376]">Services</span>
          </h1>
        </div>

        {/* Right scrolling images */}
        <div className="flex flex-col space-y-10">
          {services.map((item, index) => (
            <div
              key={index}
              className="service-card relative bg-[#F8F6FF] rounded-2xl shadow-md overflow-hidden group"
            >
              {/* Image + Overlay Wrapper */}
              <div className="relative">
                {/* Background Image */}
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-[400px] object-cover rounded-t-2xl transition-all duration-700 ease-[cubic-bezier(0.25,0.8,0.25,1)] group-hover:scale-105 group-hover:brightness-[0.9]"
                />

                {/* Glass Card on Hover (now inside image area only) */}
                <div
                  className="absolute inset-0 flex justify-center items-center opacity-0 group-hover:opacity-100 group-hover:[backdrop-filter:blur(20px)]"
                  style={{
                    transition:
                      "opacity 0.5s ease, backdrop-filter 0.6s ease, transform 0.6s ease",
                    backdropFilter: "blur(2px)",
                  }}
                >
                  <div className="bg-white/35 border-xl border-white/20 text-black p-6 rounded-2xl w-[85%] md:w-[70%] shadow-lg transform scale-95 group-hover:scale-100 transition-transform duration-700 ease-[cubic-bezier(0.25,0.8,0.25,1)]">
                    <p className="text-[1rem] leading-relaxed font-medium text-black opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-150">
                      {index === 0 &&
                        "Trade in cubicles for conversations, and isolation for inspiration! Whether you’re a solo freelancer or part of a dynamic duo, our vibrant co-working spaces are designed to fuel creativity and boost productivity. Pick your spot, grab a coffee, and get to work alongside some seriously cool people."}
                      {index === 1 &&
                        "Why settle for boring boardrooms when you can have Brainstorm Boulevard? Whether it’s a big pitch, a team huddle, or a strategy session, our stylish and tech-savvy meeting rooms are ready to handle it all—with a side of free coffee and a whole lot of good vibes."}
                      {index === 2 &&
                        "Leave the grunt work to us! Our Task Force is here to handle your admin, tech troubles, and all those pesky little things that steal your focus. We keep the gears turning so you can keep the ideas flowing."}
                      {index === 3 &&
                        "Make a big impression without the big expense! With our Virtual Office Services, get a prestigious address, mail handling, and all the perks of an office without actually having to be there. It’s your office in the cloud, so you can stay grounded wherever you are."}
                    </p>

                    <p className="text-[1rem] mt-4 font-medium text-black opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-300">
                      {index === 0 &&
                        "Jump into the Commons and create something amazing today!"}
                      {index === 1 &&
                        "Book your spot on the Boulevard and make things happen!"}
                      {index === 2 &&
                        "Deploy the Task Force and focus on what you do best!"}
                      {index === 3 &&
                        "Get your Cloud HQ and level up your business presence!"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Title + Button Below Image */}
              <div className="flex items-center justify-between px-6 py-4 bg-[#fff4f8]">
                <p className="text-lg font-medium text-gray-800">{item.title}</p>
                <button onClick={() => handleExplore(item.title)} className="flex items-center gap-2 bg-black text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-[#966376] transition-all duration-300">
                  Explore Now
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="currentColor"
                    className="w-4 h-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="min-h-screen font-RedHat py-10 flex flex-col items-center space-y-5">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{ ease: "easeInOut", duration: 0.5 }}
          className="text-4xl font-RedHat font-bold text-center capitalize"
        >
          What We <span className="text-primary">offer</span>
        </motion.h2>

        {/* Parent flex wrapper to ensure equal height */}
        <div className="w-[90%] flex flex-row flex-wrap rounded-lg overflow-hidden lg:min-h-[500px]">
          {/* Left Section */}
          <div className="bg-primary lg:w-1/2 w-full p-8 flex flex-col gap-10 justify-center">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false }}
              transition={{ ease: "easeInOut", duration: 0.5 }}
              className="text-2xl font-Poppins text-white font-semibold text-center"
            >
              Perks aplenty, <br />
              when you are at Offis Bay
            </motion.h2>

            <div className="grid grid-cols-2 lg:grid-cols-3 gap-10">
              {features.map((item, index) => (
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: false }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                  key={index}
                  className="flex flex-col items-center space-y-2 text-white"
                >
                  <LazyLoad throttle={200}>
                    <div className="h-[50px]">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="h-full w-full object-contain"
                      />
                    </div>
                  </LazyLoad>
                  <h4 className="text-center font-medium">{item.title}</h4>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Right Section (Swiper) */}
          <div className="lg:w-1/2 w-full flex items-center">
            <Swiper
              pagination={{ clickable: true }}
              speed={1000}
              centeredSlides={true}
              navigation={true}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              loop={true}
              slidesPerView={1}
              modules={[Autoplay, Pagination, Navigation]}
              className=" mySwiper w-full h-full"
            >
              <SwiperSlide>
                <div className="h-full flex items-center justify-center">
                  <img
                    src={p2}
                    alt="Slider Image 2"
                    className="w-full h-full object-cover"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="h-full flex items-center justify-center">
                  <img
                    src={p3}
                    alt="Slider Image 3"
                    className="w-full h-full object-cover"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="h-full flex items-center justify-center">
                  <img
                    src={p4}
                    alt="Slider Image 4"
                    className="w-full h-full object-cover"
                  />
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>

      <section className="font-RedHat py-10 flex flex-col items-center gap-16">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{ ease: "easeInOut", duration: 0.5 }}
          className="text-4xl font-RedHat font-bold text-center"
        >
          Accessibility and Nearby{" "}
          <span className="text-primary">Conveniences</span>
        </motion.h2>
        <div className="w-[90%] grid grid-cols-1 lg:grid-cols-5 items-center justify-center gap-32">
          {nearbyConvenience.map((item, index) => (
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: false }}
              transition={{ duration: 1, ease: "easeInOut" }}
              key={index}
              className="flex flex-col items-center space-y-2 text-black"
            >
              <div className="h-[70px]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-full w-full object-contain"
                />
              </div>
              <h4 className="text-center font-medium text-[0.8rem] text-primary">
                {item.title}
                <br />
                {item.distance}
              </h4>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="font-RedHat py-10 flex flex-col items-center space-y-5 gap-10">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{ ease: "easeInOut", duration: 0.5 }}
          className="text-4xl font-RedHat font-bold text-center"
        >
          Find Your Perfect Spot at{" "}
          <span className="text-primary">Offis Bay</span>
        </motion.h2>
        <div className=" w-[90%] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:gap-30 gap-5  place-items-center">
          {workSpaceData.map((obj, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false }}
              transition={{ ease: "easeInOut", duration: 0.9 }}
              className="h-[250px] lg:w-[285px]  md:w-[280px] w-full group  relative flex items-end justify-center rounded-xl overflow-hidden"
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${obj.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="absolute bg-primary/50  inset-x-0 h-0  group-hover:h-full transition-all ease-in-out duration-300 rounded-tl-xl rounded-br-xl overflow-hidden flex flex-col gap-5 items-center justify-center">
                <motion.button
                  onClick={() => {
                    document
                      .querySelector("#requestcallback")
                      .scrollIntoView({ behavior: "smooth" });
                  }}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false }}
                  transition={{ ease: "easeInOut", duration: 0.5 }}
                  className="bg-primary border-2 text-white border-transparent w-[240px] py-2 px-8 text-[0.8rem] rounded-md overflow-hidden font-Montserrat relative group"
                >
                  <div className="absolute inset-0 border-2 border-transparent bg-white/10 w-0 group-hover:w-full transition-all ease-in-out duration-300 rounded-md"></div>
                  Request A Visit
                </motion.button>
                <Link to={"/offis-spaces"} state={{ spaceId: `${obj.id}` }}>
                  <motion.button
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false }}
                    transition={{ ease: "easeInOut", duration: 0.5 }}
                    className="bg-primary border-2 text-white border-transparent w-[240px] py-2 px-8 text-[0.8rem] rounded-md overflow-hidden font-Montserrat relative group"
                  >
                    <div className="absolute inset-0 border-2 border-transparent bg-white/10 w-0 group-hover:w-full transition-all ease-in-out duration-300 rounded-md"></div>
                    Book Your Space
                  </motion.button>
                </Link>
              </div>
              <motion.h2 className="text-[1.3rem] w-full group-hover:hidden text-white font-bold text-center transform -translate-x-1/2 -translate-y-1/2 absolute left-1/2 top-1/2">
                {obj.roomName}
              </motion.h2>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="py-12 sm:py-16 px-4 sm:px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-8">
            <div>
              <p className="text-[#966376] text-xs sm:text-sm uppercase tracking-[0.18em] font-semibold">Our Partner Ecosystem</p>
              <h3 className="text-[#0B2549] font-regrade text-2xl sm:text-3xl md:text-4xl font-bold mt-3 leading-tight">
                Trusted Partners Supporting
                <br className="hidden sm:block" /> Modern Businesses
              </h3>
            </div>
            <Link to="/partners" className="inline-flex">
              <button className="bg-[#966376] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#7d5262] transition-colors text-sm sm:text-base">
                View All Partners
              </button>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {partnersPreview.map((partner) => (
              <a
                key={partner.name}
                href={partner.website}
                target="_blank"
                rel="noreferrer"
                className="rounded-2xl border border-[#ECE4DF] p-5 bg-[#FCFAF8] hover:shadow-sm transition-shadow"
              >
                <div className="h-14 flex items-center">
                  <img src={partner.logo} alt={partner.name} className="h-full max-w-[180px] object-contain" />
                </div>
                <p className="mt-4 text-[#0B2549] font-semibold">{partner.name}</p>
                {partner.tagline && (
                  <p className="text-[10px] tracking-[0.14em] uppercase mt-1 text-[#2A3650] font-semibold">{partner.tagline}</p>
                )}
                <p className="text-[#966376] text-xs uppercase tracking-wider mt-1">{partner.category}</p>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Services Teaser Section */}
      <section className="py-12 sm:py-16 px-4 sm:px-6 bg-[#FFF4F8]">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-[#966376] font-sans text-base font-semibold uppercase text-center mb-2 tracking-wider">
            OUR SERVICES
          </h2>
          <h3
            style={{ lineHeight: 1.2 }}
            className="text-[#0B2549] font-regrade text-3xl md:text-5xl font-bold text-center mb-10"
          >
            Beyond Coworking — Complete<br className="hidden sm:block" /> Facility &amp; Security Solutions
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10">
            {[
              {
                Icon: IconSparkles,
                title: "Facility Management & Housekeeping",
                desc: "Daily janitorial, floor care, pantry management, pest control, and HVAC disinfection for offices and industrial sites.",
              },
              {
                Icon: IconShield,
                title: "Security & Guarding Services",
                desc: "Manned guarding, CCTV surveillance, biometric access control, and industrial loss prevention — tailored to your needs.",
              },
              {
                Icon: IconUsers,
                title: "Manpower Outsourcing",
                desc: "Pre-trained, compliant staff with full PF, ESI and labour law coverage. Scale up or down as your business demands.",
              },
            ].map(({ Icon, title, desc }, i) => (
              <div
                key={i}
                className="bg-[rgba(255,244,248,1)] rounded-2xl p-6 flex flex-col gap-4"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-white rounded-xl shadow-sm flex-shrink-0">
                  <Icon size={22} className="text-[#966376]" strokeWidth={1.5} />
                </div>
                <h4 className="text-[#0B2549] font-sans font-semibold text-base leading-snug">
                  {title}
                </h4>
                <p className="text-[#6D7E94] text-sm leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
          <div className="flex justify-center">
            <Link to="/services">
              <button className="bg-[#966376] text-white px-8 py-3 rounded-[30px] font-semibold hover:bg-[#7d5262] transition-colors text-sm sm:text-base">
                Explore All Services →
              </button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
